import type { Components, Theme } from "@mui/material";

export const menuItemTheme: Components<Theme>["MuiMenuItem"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    }),
  },
};
